import React, {useState} from 'react';
import withCaretakers from "../../../hoc/withCaretakers";
import css from "./AddItem.module.css";
import {BottomBar, Tour} from "../../../components";
import {TitleWrapper} from "../../../contexts/TitleProvider";
import i18n from "../../../i18n";
import {getPageHelpSteps} from "../../../help/tools";

const AddItemButton = props => {
    return (
        <div className={css.button + " " + props.className} onClick={props.onClick}>{props.text}</div>
    );
}

const AddItem = props => {
    const [helpOpen, setHelpOpen] = useState(false);
    const doHelp                  = () => setHelpOpen(true);
    const closeHelp               = () => setHelpOpen(false);

    return (
        <TitleWrapper title={props.caretaker ? props.caretaker.name : i18n.caretakersItemAdd}>
            <Tour
                isOpen={helpOpen}
                onRequestClose={closeHelp}
                steps={getPageHelpSteps("caretakerAddItem")}
            />
            <div>
                <div className="content-list">
                    <AddItemButton
                        className={css.tourMessage}
                        text={i18n.caretakersMessage}
                        onClick={() => props.history.push('/caretakers/message/send/' + props.caretakerUuid)}
                    />
                    <AddItemButton
                        className={css.tourAppointment}
                        text={i18n.calendarTypeSingular.appointment}
                        onClick={() => props.history.push('/caretakers/calendar/appointments/' + props.caretakerUuid + '/edit/new')}
                    />
                    <AddItemButton
                        className={css.tourReminder}
                        text={i18n.calendarTypeSingular.reminder}
                        onClick={() => props.history.push('/caretakers/calendar/reminders/' + props.caretakerUuid + '/edit/new')}
                    />
                    <AddItemButton
                        className={css.tourTvProgram}
                        text={i18n.calendarTypeSingular.tvshow}
                        onClick={() => props.history.push('/caretakers/calendar/tvshows/' + props.caretakerUuid + '/edit/new')}
                    />
                    <AddItemButton
                        className={css.tourBirthday}
                        text={i18n.calendarTypeSingular.birthday}
                        onClick={() => props.history.push('/caretakers/calendar/birthdays/' + props.caretakerUuid + '/edit/new')}
                    />
                    <BottomBar
                        backButton
                        links={[{title: i18n.calendarDefaultSettings, link: "/caretakers/calendar/defaultsettings/" + props.caretakerUuid}]}
                        onHelp={doHelp} onCloseHelp={closeHelp} helpOpen={helpOpen}
                    />
                </div>
            </div>
        </TitleWrapper>
    );
}


export default withCaretakers(AddItem);